
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 20a6.5 6.5 0 100-13 6.5 6.5 0 000 13z","stroke":"#fff","stroke-width":"1.4","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M19.427 7.242A6.5 6.5 0 1121.19 20","stroke":"#56BFC7","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 24.675a11.002 11.002 0 0118-.001","stroke":"#fff","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.19 20a10.987 10.987 0 019 4.674","stroke":"#56BFC7","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    